import { RouteConfig, NavigationGuard } from 'vue-router';
import { AdminRoles } from '@/configs/role';
import { ServiceTypes, serviceTypeList } from '@/configs/service-form';

const checkServiceType: NavigationGuard = (to, from, next) => {
  if (!to.params.serviceType) {
    next({
      name: 'service-list',
      params: {
        serviceType: ServiceTypes.LAND,
      },
    });
    return;
  }

  if (serviceTypeList.includes(to.params.serviceType as ServiceTypes)) {
    next();
    return;
  }

  next({
    name: 'service-list',
    params: {
      serviceType: ServiceTypes.LAND,
    },
  });
};

const serviceRoutes: RouteConfig = {
  path: 'service-form',
  component: () => import(/* webpackChunkName: 'dashboard.service' */ '@/pages/form/Index.vue'),
  redirect: {
    name: 'service-list',
    params: {
      serviceType: ServiceTypes.LAND,
    },
  },
  children: [
    {
      path: ':serviceType/list',
      name: 'service-list',
      component: () => import(/* webpackChunkName: 'dashboard.service' */ '@/pages/form/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
      beforeEnter: checkServiceType,
    },
  ],
};

export default serviceRoutes;
